
import { List, Datagrid, TextField, DateField, NumberField } from 'react-admin';

export const Tbl_cartellinoList = props => (
    <List {...props}>
        <Datagrid rowClick="edit">
            <NumberField source="id" />
            <NumberField source="partitaId" />
            <NumberField source="playerId" />
            <NumberField source="tipoCartellinoId" />
            <NumberField source="minuto" />
            <TextField source="note" />
            <NumberField source="flVisibile" />
            <NumberField source="flAttivo" />
            <NumberField source="flAnnullato" />
            <NumberField source="ordinamento" />
            <DateField source="createdAt" />
            <DateField source="updatedAt" />
        </Datagrid>
    </List>
);
            